import { render, staticRenderFns } from "./Consistenza.vue?vue&type=template&id=5dbb658a&scoped=true&"
import script from "./Consistenza.vue?vue&type=script&lang=js&"
export * from "./Consistenza.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dbb658a",
  null
  
)

export default component.exports